const SET_DANH_SACH_THONG_BAO = (state, danhSachThongBao) => {
  state.danhSachThongBao = danhSachThongBao;
};

const SET_TOTAL_NOT_SEEN = (state, payload) => {
  state.danhSachThongBao.CountChuaXem = payload
}

export default {
  SET_DANH_SACH_THONG_BAO,
  SET_TOTAL_NOT_SEEN
};
